import React from 'react';
import { ListItemText, MenuItem, Select, alpha } from '@mui/material';

// /////////////////////////////////////////////////////////////////////////////////////////////////
export const TzViewTBSelect = (props) => {
  const { value, onChange, name, sx } = props;
  const allOptions = [
    { name: 'Fleet timezone', value: 'Fleet' },
    { name: 'Local timezone', value: 'Local' },
  ];

  return (
    <Select
      id='tz-view-select'
      color='controls'
      name={name}
      size='small'
      sx={[
        {
          color: (theme) => theme.palette.primary.main,
          width: '160px',
          borderRadius: '8px',
          height: { md: '40px', xs: '32px' },
          '& .MuiInputBase-input': { py: 1, px: 1, lineHeight: '24px' },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: (theme) => alpha(theme.palette.primary.main, 0.5),
          },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: (theme) => theme.palette.primary.main },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: (theme) => theme.palette.primary.main,
          },
          '& .MuiSelect-icon': { color: (theme) => theme.palette.primary.main },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      MenuProps={{
        PaperProps: {
          style: { borderRadius: '8px' },
          sx: {
            background:(theme)=>theme.palette.background.main,
            '& .MuiMenuItem-root': {
              '&:hover': {
                backgroundColor: (theme) => theme.palette.background.light5,
              },
            },
            '&.Mui-selected': {
              backgroundColor: (theme) => theme.palette.primary.main,
            },
          },
        },
      }}
    >
      {allOptions.map((opt) => (
        <MenuItem
          key={opt.name}
          value={opt.value}
          sx={{
            pl: '4px',
            py: '2px',
            '& .MuiTypography-root': { fontSize: '14px' },
            '&:hover': { backgroundColor: (theme) => theme.palette.background.light5 },
          }}
        >
          <ListItemText primary={opt.name} />
        </MenuItem>
      ))}
    </Select>
  );
};
